import React from 'react';
import * as CollapsiblePrimitive from '@radix-ui/react-collapsible';
import { ChevronRight } from 'lucide-react';

import { cn } from '@/lib/utils';

const Collapsible = ({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.Root>) => (
  <CollapsiblePrimitive.Root
    data-slot='collapsible'
    {...props}
  />
);

const CollapsibleTrigger = ({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) => (
  <CollapsiblePrimitive.CollapsibleTrigger
    data-slot='collapsible-trigger'
    {...props}
  />
);

type CollapsibleHeadingProps = Omit<
  React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>,
  'asChild' | 'children'
> & {
  children: React.ReactNode;
  collapsible?: boolean;
  isOpen?: boolean;
};

const CollapsibleHeading = ({
  children,
  collapsible = true,
  className,
  disabled,
  isOpen,
  ...props
}: CollapsibleHeadingProps) => (
  <CollapsiblePrimitive.CollapsibleTrigger
    data-slot='collapsible-heading'
    disabled={disabled ?? !collapsible}
    className={cn('cursor-pointer', className)}
    {...props}>
    <ChevronRight
      className={cn('transition-transform duration-200 ease-in-out', {
        'rotate-90': isOpen,
      })}
      aria-hidden='true'
    />
    {children}
  </CollapsiblePrimitive.CollapsibleTrigger>
);

const CollapsibleContent = ({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) => (
  <CollapsiblePrimitive.CollapsibleContent
    data-slot='collapsible-content'
    {...props}
  />
);

export {
  Collapsible,
  CollapsibleContent,
  CollapsibleHeading,
  CollapsibleTrigger,
};
